import React from 'react'
import IconButtonUI from "./IconButtonUI";

const IconUploadButtonUI = ({messageList, icon, selected, onClick, labelKey, shortCutKey}) => {

  const hiddenFileInput = React.useRef(null);

  const handleFileUpload = event => {
    onClick(event.target.files[0]);
    event.preventDefault();

    // Allow to reuse file upload input
    event.target.value = '';
  };

  const handleClick = event => {
    hiddenFileInput.current.click();
  };

  return (
    <>
      <IconButtonUI messageList={messageList} icon={icon} onClick={handleClick} labelKey={labelKey} selected={selected} shortCutKey={shortCutKey}/>
      <input
        type="file"
        ref={hiddenFileInput}
        onChange={handleFileUpload}
        style={{display: 'none'}}
      />
    </>
  );
}
export default IconUploadButtonUI;
